import styles from './index.module.scss';
import { useState } from 'react';
import useHeadOpacityScroll from '@/hooks/useHeadOpacityScroll';
import backImg from '@/assets/img/arrow-left-black.png';
import wxShareIcon from '@/assets/img/wx-share.png';
import useParams from '@/hooks/useParams';
import useRouterToNativeRouter, { V5JSBridge } from '@/hooks/useRouterToNativeRouter';

export default function HeadOpacityScrollContainer({
  children,
  title = 'AI-Tutor is coming!',
  hide = false,
  watchImg = false,
  showShare = false,
  onShare = () => {},
}: {
  children?: React.ReactNode;
  title?: string;
  hide?: boolean;
  watchImg?: boolean;
  showShare?: boolean;
  onShare?: () => void;
}) {
  const ua = navigator.userAgent;
  const [navBarHeight] = useState<number>(() => {
    const navBarMatch = ua.match(/navBarHeight\/(\d+)/);
    return navBarMatch ? +navBarMatch[1] : 44;
  });
  const routerToNativeRouter = useRouterToNativeRouter();
  const { opacity } = useHeadOpacityScroll({ watchImg });
  const { queryParams } = useParams();
  const { back_btn_home } = queryParams;
  const isMaxWidth451 = location.pathname.includes('/active-page');

  const handleBack = () => {
    if (back_btn_home) {
      routerToNativeRouter({ router: 'yawwaixue://home' });
      return;
    }
    V5JSBridge.returnBack?.();
  };

  const handleShare = () => {
    onShare?.();
  };

  if (hide) {
    return children;
  }

  return (
    <>
      {!opacity && (
        <div
          className={
            styles.headOpacityScrollContainer +
            ` ${isMaxWidth451 ? 'ignore-rem-max-width-451' : ''}`
          }
          style={{ paddingTop: `${navBarHeight}px`, background: 'transparent' }}
        >
          <div
            style={{ height: `${navBarHeight}px` }}
            className={styles.headOpacityScrollContainerBack}
          >
            <div onClick={handleBack} className={styles.headOpacityScrollContainerBackIcon}>
              <img src={backImg} alt="" />
            </div>
            {showShare && (
              <div onClick={handleShare} className={styles.headOpacityScrollContainerShareIcon}>
                <img src={wxShareIcon} alt="" />
              </div>
            )}
          </div>
        </div>
      )}
      {opacity > 0 && (
        <div
          className={
            styles.headOpacityScrollContainer +
            ` ${isMaxWidth451 ? 'ignore-rem-max-width-451' : ''}`
          }
          style={{ paddingTop: `${navBarHeight}px`, opacity }}
        >
          <div
            style={{ height: `${navBarHeight}px` }}
            className={styles.headOpacityScrollContainerBack}
          >
            <div onClick={handleBack} className={styles.headOpacityScrollContainerBackIcon}>
              <img src={backImg} alt="" />
            </div>
            <div className={styles.headOpacityScrollContainerTitle}>{title}</div>
            {showShare && (
              <div onClick={handleShare} className={styles.headOpacityScrollContainerShareIcon}>
                <img src={wxShareIcon} alt="" />
              </div>
            )}
          </div>
        </div>
      )}
      {children}
    </>
  );
}
